import React from "react";

import { BottomSheet } from "./BottomSheet";

type Props = {
  isMobile: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** The desktop rail keeps its scroll-into-view ref. */
  inspectorRef?: React.Ref<HTMLElement>;
  className?: string;
  children: React.ReactNode;
};

/**
 * Presents a screen's filter controls as a side rail on desktop and a bottom
 * sheet on a phone, from one set of markup.
 *
 * The alternative — styling the rail into a sheet with CSS — looked right but
 * left the rail's lower controls outside the viewport and behind the fixed
 * tab bar, because a rail is laid out in the page while a sheet has to be
 * measured against the screen. Swapping the container instead of restyling it
 * keeps the filter controls and their state in exactly one place.
 */
export const FilterShell: React.FC<Props> = ({
  isMobile,
  open,
  onOpenChange,
  inspectorRef,
  className,
  children,
}) => {
  if (isMobile) {
    return (
      <BottomSheet open={open} onOpenChange={onOpenChange} title="Filters">
        {children}
      </BottomSheet>
    );
  }

  return (
    <aside ref={inspectorRef} className={className} aria-label="Filters">
      {children}
    </aside>
  );
};
